module.exports = __webpack_public_path__ + "static/img/sm_26.ba3492d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_26.png
// module id = PEbO
// module chunks = 0